import { Plugin } from 'ckeditor5';
import { ConditionState } from './State';
import { ConditionsSchema } from './schema';
import { ConditionsUI } from './ui';
import './augmentation';
export class ConditionsPlugin extends Plugin {
    static get pluginName() {
        return 'ConditionsPlugin';
    }
    static get requires() {
        return [ConditionState, ConditionsSchema, ConditionsUI];
    }
}
